// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Activity from "./activity.js"
import Competition from "./competition.js"
import Contact from "./contact.js"
import Organization from "./organization.js"
import SchoolClass from "./school-class.js"
import TeamApplication from "./team-application.js"
import TeamSurvey from "./team-survey.js"
import TeamUser from "./team-user.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "competition_id": {
      "column": {
        "default": null,
        "name": "competition_id",
        "null": true,
        "type": "uuid"
      },
      "name": "competition_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "team_type": {
      "column": {
        "default": null,
        "name": "team_type",
        "null": false,
        "type": "string"
      },
      "name": "team_type",
      "selected_by_default": null,
      "translated": null
    },
    "team_users_count": {
      "column": {
        "default": 0,
        "name": "team_users_count",
        "null": false,
        "type": "integer"
      },
      "name": "team_users_count",
      "selected_by_default": null,
      "translated": null
    },
    "translated_team_type": {
      "column": null,
      "name": "translated_team_type",
      "selected_by_default": null,
      "translated": null
    },
    "enough_members": {
      "column": null,
      "name": "enough_members",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Team",
  "collectionKey": "teams",
  "collectionName": "teams",
  "i18nKey": "team",
  "camelizedLower": "team",
  "name": "Team",
  "nameDasherized": "team",
  "pluralName": "teams",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "applicants",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team_applications"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "owner"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "school"
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "HighscoreGenerationTeam",
      "collectionName": "highscore_generation_teams",
      "foreignKey": "team_id",
      "name": "highscore_generation_teams",
      "macro": "has_many",
      "resource_name": "HighscoreGenerationTeam",
      "through": null
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscores",
      "macro": "has_many",
      "resource_name": "Highscore",
      "through": "highscore_generation_teams"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "owner",
      "macro": "has_one",
      "resource_name": "User",
      "through": "owner_team_user"
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "owner_team_user",
      "macro": "has_one",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "owner"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "owner"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "surveys",
      "macro": "has_many",
      "resource_name": "Survey",
      "through": "team_surveys"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "TeamApplication",
      "collectionName": "team_applications",
      "foreignKey": "team_id",
      "name": "team_applications",
      "macro": "has_many",
      "resource_name": "TeamApplication",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team_users"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "anonymized",
      "column": {
        "default": false,
        "name": "anonymized",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "competition_id",
      "column": {
        "default": null,
        "name": "competition_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deprecated_school_class_id",
      "column": {
        "default": null,
        "name": "deprecated_school_class_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "deprecated_school_id",
      "column": {
        "default": null,
        "name": "deprecated_school_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_competition_id",
      "column": {
        "default": null,
        "name": "old_competition_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_school_class_id",
      "column": {
        "default": null,
        "name": "old_school_class_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_school_id",
      "column": {
        "default": null,
        "name": "old_school_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "team_type",
      "column": {
        "default": null,
        "name": "team_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "team_users_count",
      "column": {
        "default": 0,
        "name": "team_users_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "owner"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "owner"
    },
    {
      "className": "TeamApplication",
      "collectionName": "team_applications",
      "foreignKey": "team_id",
      "name": "team_applications",
      "macro": "has_many",
      "resource_name": "TeamApplication",
      "through": null
    },
    {
      "className": "TeamSurvey",
      "collectionName": "team_surveys",
      "foreignKey": "team_id",
      "name": "team_surveys",
      "macro": "has_many",
      "resource_name": "TeamSurvey",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team_users"
    }
  ],
  "paramKey": "team",
  "primaryKey": "id"
}

/** Frontend model for Team. */
export default class Team extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  competitionId() {
    return this.readAttributeUnderscore("competition_id")
  }

  /** @returns {boolean} */
  hasCompetitionId() {
    const value = this.competitionId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string} */
  teamType() {
    return this.readAttributeUnderscore("team_type")
  }

  /** @returns {boolean} */
  hasTeamType() {
    const value = this.teamType()

    return this._isPresent(value)
  }

  /** @returns {number} */
  teamUsersCount() {
    return this.readAttributeUnderscore("team_users_count")
  }

  /** @returns {boolean} */
  hasTeamUsersCount() {
    const value = this.teamUsersCount()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedTeamType() {
    return this.readAttributeUnderscore("translated_team_type")
  }

  /** @returns {boolean} */
  hasTranslatedTeamType() {
    const value = this.translatedTeamType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  enoughMembers() {
    return this.readAttributeUnderscore("enough_members")
  }

  /** @returns {boolean} */
  hasEnoughMembers() {
    const value = this.enoughMembers()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  apply(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "apply",
        primaryKey: this.primaryKey(),
        collectionName: "teams",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readBelongsToReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("activityId" in this)) throw new Error("Foreign key method wasn't defined: activityId")

    const id = this.activityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }

  /** @returns {import("./competition.js").default | null} */
  competition() {
    return this._readBelongsToReflection({modelClass: Competition, reflectionName: "competition"})
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  loadCompetition() {
    if (!("competitionId" in this)) throw new Error("Foreign key method wasn't defined: competitionId")

    const id = this.competitionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "competition",
        model: this,
        modelClass: Competition
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  ensureCompetitionLoaded() {
    return this.ensureAssociationLoaded("competition")
  }

  /** @returns {import("./contact.js").default | null} */
  region() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "region"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadRegion() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "region",
        model: this,
        modelClass: Contact
      },
      {
        params: {
          through: {
            model: "Team",
            id,
            reflection: "region"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureRegionLoaded() {
    return this.ensureAssociationLoaded("region")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {
        params: {
          through: {
            model: "Team",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readHasOneReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "Team",
            id,
            reflection: "school_class"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureSchoolClassLoaded() {
    return this.ensureAssociationLoaded("school_class")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-application.js").default>} */
  teamApplications() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_applications",
        model: this,
        modelClass: TeamApplication
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-application.js").default>>} */
  loadTeamApplications() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_applications",
        model: this,
        modelClass: TeamApplication
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-application.js").default>>} */
  ensureTeamApplicationsLoaded() {
    return this.ensureAssociationLoaded("team_applications")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-survey.js").default>} */
  teamSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_surveys",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey.js").default>>} */
  loadTeamSurveys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_surveys",
        model: this,
        modelClass: TeamSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-survey.js").default>>} */
  ensureTeamSurveysLoaded() {
    return this.ensureAssociationLoaded("team_surveys")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./team-user.js").default>} */
  teamUsers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "team_users",
        model: this,
        modelClass: TeamUser
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-user.js").default>>} */
  loadTeamUsers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "team_users",
        model: this,
        modelClass: TeamUser
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./team-user.js").default>>} */
  ensureTeamUsersLoaded() {
    return this.ensureAssociationLoaded("team_users")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user.js").default>} */
  users() {
    return new Collection(
      {
        reflectionName: "users",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "Team",
            id: this.primaryKey(),
            reflection: "users"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  loadUsers() {
    return this._loadHasManyReflection(
      {
        reflectionName: "users",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "Team",
            id: this.primaryKey(),
            reflection: "users"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  ensureUsersLoaded() {
    return this.ensureAssociationLoaded("users")
  }
}
